import { FieldErrors, UseFormRegister } from 'react-hook-form'
import classNames from 'classnames'
import { Checkbox } from '~/components/Checkbox'
import { Link } from '~/components/Link'
import { PasswordInput } from '~/components/PasswordInput'
import { usePage } from '~/hooks'
import { DEFAULT_COUNTRY_CODE_AU } from '~/constants/countries'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './AuthenticationDrawer.module.scss'
import { PasswordValidationsContainer } from './PasswordValidationsContainer'

interface PasswordDetailsFormProps {
  register: UseFormRegister<{
    newPassword: string
    confirmPassword: string
    subscribeToNewsletter: boolean
  }>
  errors: FieldErrors<{
    newPassword: string
    confirmPassword: string
  }>
  newPassword: string
}

const PasswordDetailsForm = ({
  register,
  errors,
  newPassword,
}: PasswordDetailsFormProps) => {
  const { countryCode } = usePage()
  const privacyUrl =
    countryCode === DEFAULT_COUNTRY_CODE_AU
      ? 'https://help.jaycar.com.au/hc/en-us/articles/22474587557785'
      : 'https://help.jaycar.co.nz/hc/en-us/articles/22474611169433'

  const termsAndConditions =
    countryCode === DEFAULT_COUNTRY_CODE_AU
      ? 'https://help.jaycar.com.au/hc/en-us/articles/22444740358809-Jaycar-Club-terms-conditions'
      : 'https://help.jaycar.co.nz/hc/en-us/articles/22444761273113-Jaycar-Club-terms-conditions'

  return (
    <div>
      <div className={styles.formContainer}>
        <PasswordInput
          name='newPassword'
          label='New Password'
          required
          type='password'
          register={register}
          error={errors.newPassword?.message.toString()}
        />
        <PasswordInput
          name='confirmPassword'
          label='Confirm Password'
          required
          type='password'
          register={register}
          error={errors.confirmPassword?.message.toString()}
        />
      </div>
      <div className='my-4'>
        <PasswordValidationsContainer value={newPassword} />
      </div>
      <div className={classNames('my-8', styles.checkboxContainer)}>
        <Checkbox
          name='subscribeToNewsletter'
          label={
            <Typography
              tag={TypographyTag.div}
              variant={TypographyVariant.BodyRegularExtraLineHeight}>
              I&apos;ve read and accept the&nbsp;
              <Link href='/member-access' className='underline' target='_blank'>
                Jaycar Rewards
              </Link>
              &nbsp;
              <Link
                href={termsAndConditions}
                className='underline'
                target='_blank'>
                Terms & Conditions
              </Link>
              &nbsp;and&nbsp;
              <Link href={privacyUrl} className='underline' target='_blank'>
                Privacy Policy
              </Link>
              ,&nbsp;which includes how Jaycar Rewards may send me marketing and
              &nbsp;program-related messages, and how I can opt out or
              &nbsp;unsubscribe at any time.
            </Typography>
          }
          size='lg'
          register={register}
          defaultChecked
          theme={{
            root: 'items-start',
            content: 'max-w-none',
          }}
        />
      </div>
    </div>
  )
}

export default PasswordDetailsForm
